module.exports = __webpack_public_path__ + "img/skrill.4a1f8da1.svg";